module.exports = __webpack_public_path__ + "media/images/riders/small/MICHAEL_HANNAH-951c9739eeac14540bfa2fcfd905ad62.png";